import { memo } from "react";
import { Box } from "@mui/material";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography, DefaultComponentProps } from "@albo-ui/core";
import alertInfo from "../../../images/alert-info.png";

export type ConfirmDialogDialogProps = {
    onConfirm: (text?: string) => void;
    onClose: () => void;
    open: boolean;
    text: object;
    item?: string;
    element?: any;
} & DefaultComponentProps;

const DeleteEvent = ({    onConfirm, onClose, open, text, item, element }: ConfirmDialogDialogProps) => {
    const validate = (img) => {
        switch (img) {
            case "delete":
                return alertInfo;
            default:
                break;
        }
    };

    return (
        <Dialog onClose={onClose} open={open} style={{ textAlignLast: "center" }}>
            <DialogTitle>
                <Box sx={{ display: "grid" }}>
                    <Box component="img" src={validate(element)} alt="emptyList" justifySelf={"center"} width={180} mb={2}/>
                    <Typography variant="h2">{text["title"]}</Typography>
                </Box>
            </DialogTitle>

            <DialogContent>
                <FlexGrid>
                    <Typography variant="paragraph">{text["message"]}</Typography>
                </FlexGrid>
                {item && (
                    <FlexGrid style={{ marginTop: 20 }}>
                        <hr />
                        <Typography variant="paragraph" bold>{item}</Typography>
                    </FlexGrid>
                )}
            </DialogContent>

            <DialogActions>
                <FlexGrid container spacing={4} fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: "20px", display: "flex" }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType="secondary" size="normal" style={{ width: 190 }}>
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={onConfirm} size="normal" style={{ width: 190 }}>
                            Aceptar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};

export default memo(DeleteEvent);
